export default "__VITE_ASSET__e280d4ba__"